import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import vancatListService from "./vacantService";

export const getVacantList = createAsyncThunk(
  "VacantList/getVacantList",
  async (thunkAPI) => {
    try {
      return await vancatListService.getVacantList();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_all");

const initialState = {
  vacantLists: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const vacantSlice = createSlice({
  name: "vacantList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVacantList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getVacantList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.vacantLists = action.payload;
      })
      .addCase(getVacantList.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default vacantSlice.reducer;
